import { MESSAGING_METRICS, SMS_METRICS } from 'modules/billing/constants';

export const MESSAGING_CARD_IDS = {
  cardId: 'messaging-usage-card',
};

export const MESSAGING_CARD_TEXT = {
  cardTitle: 'Messaging',
  emailBreakdownEmailsSentMetricName: 'To sends',
  emailBreakdownCCEmailsSentMetricName: 'CC sends',
  emailBreakdownBCCEmailsSentMetricName: 'BCC sends',
  emailMetricName: 'Email',
  smsMetricName: 'SMS',
  mmsMetricName: 'MMS',
  projectBreakdownUrl: '/payments/info/messagingUsage',
  pushMetricName: 'Push',
  webPushMetricName: 'Web push',
  inAppMetricName: 'In-app',
  whatsAppMetricName: 'WhatsApp',
};

export const MESSAGING_METRIC_NAMES = [
  MESSAGING_METRICS.emailsSent,
  SMS_METRICS.smsSegmentsSent,
  SMS_METRICS.mmsAttachmentsSent,
  MESSAGING_METRICS.pushNotificationsSent,
  MESSAGING_METRICS.webPushNotificationsSent,
  MESSAGING_METRICS.inAppNotificationsSent,
  MESSAGING_METRICS.whatsAppSent,
];

export const EMAIL_BREAKDOWN_TABLE_COLUMNS = [
  { label: 'Email breakdown' },
  { isNumeric: true, label: 'Total' },
];
